<template>
  <SectionTemplate
    title="塑造个人和品牌的专属视觉空间"
    subTitle="个性化编辑场景"
    desc="在视觉竞争的时代，专属场景是构建品牌护城河的关键。
我们提供从灵活的场景编辑到深度的企业场景定制全方案，将您的品牌理念与视觉风格深度融合，沉淀为不可复制的核心视觉资产。"
  >
    <div class="card-list">
      <EditCard v-for="item in list" :key="item.path" :data="item">
        <template #btn>
          <component :is="item.btn" />
        </template>
      </EditCard>
    </div>
  </SectionTemplate>
</template>

<script setup lang="ts">
import EditCard from '@/design/components/edit-card/index.vue';
import { getFeUrl } from '@/utils/url';
import SectionTemplate from '~/design/widgets/landing-section/cn-template.vue';
import ConsultPricingPlanBtn from '../../components/consult-pricing-plan.vue';
import ExperienceBtn from '../../components/experience-editor.vue';

const list = [
  {
    title: '场景编辑',
    des: '提供便捷的在线编辑器，您可以实时调整场景元素、LOGO、文字等，实现所见即所得。让创意修改和版本迭代无比高效，确保最终呈现的视频背景百分百符合预期，大幅优化团队协作效率。',
    path: getFeUrl('/youyan-platform/scene/customization/scene-edit.jpg'),
    btn: ExperienceBtn,
  },
  {
    title: '场景定制',
    des: '当预设库无法满足您的独特需求，我们提供专业的场景定制服务。无论是复现线下实体场景，还是构建天马行空的虚拟空间，我们都能为您打造专属于品牌的3D场景，成为您的核心视觉竞争力。',
    path: getFeUrl('/youyan-platform/scene/customization/scene-customize.jpg'),
    btn: ConsultPricingPlanBtn,
  },
];
</script>

<style lang="scss" scoped>
.card-list {
  width: 100%;
  display: flex;
  gap: 40px;
}
</style>
